<script>
  import CenterDesc from './center-desc.svelte';
  import { onMount } from 'svelte';

  let map, marker;
  let markerOptions;
  function initMap() {
    map = new naver.maps.Map('meju-map', {
      center: new naver.maps.LatLng(36.124797, 128.329072),
      zoom: 16,
      zoomControl: true, //줌 컨트롤의 표시 여부
      zoomControlOptions: {
        //줌 컨트롤의 옵션
        position: naver.maps.Position.TOP_RIGHT,
      },
    });
    markerOptions = {
      position: new naver.maps.LatLng(36.124797, 128.329072),
      map: map,
      // icon: {
      //   url: '/imgs/meju80.png',
      //   size: new naver.maps.Size(80, 120),
      //   origin: new naver.maps.Point(0, 0),
      //   anchor: new naver.maps.Point(40, 120),
      // },
    };
    marker = new naver.maps.Marker(markerOptions);
  }
  const openMapLink = () =>
    window
      .open(
        'https://map.naver.com/v5/entry/place/1362981041?c=14285556.8232815,4317986.5170284,16,0,0,0,dh&placePath=%2Fhome%3Fentry=plt',
        '_blank'
      )
      .focus();
</script>

<svelte:head>
  <script
    src="https://openapi.map.naver.com/openapi/v3/maps.js?ncpClientId=ig9rgh00r9&callback=initMap"
    on:load={initMap}></script>
</svelte:head>

<div class="container">
  <div class="content title">위치</div>
  <div class="content desc">
    주소 : 구미시 금오산로 22길 6<br />지하1층 황금메쥬
  </div>
  <div class="info">* 주차는 별도로 문의해주세요.</div>
  <div class="content map-wrapper">
    <!-- <img class="content map" src="/imgs/map1.png" alt="지도" /> -->
    <div class="map-link" on:click={openMapLink}>네이버에서 보기</div>
    <div id="meju-map" class="content map" />
  </div>
</div>

<style>
  .container {
    width: 100%;
    height: 800px;
  }
  .content {
    width: 100%;
  }

  .content.title,
  .content.desc {
    text-align: center;
    margin: 0;
    margin-bottom: 20px;
  }
  .content.title {
    font-weight: 400;
    font-size: 30px;
  }
  .content.desc {
    font-weight: 200;
    font-size: 24px;
  }
  .info {
    font-size: 18px;
    text-align: center;
  }
  .content.map-wrapper {
    position: relative;
    margin: 0;
    width: 100%;
    height: 620px;
    overflow: hidden;
    box-shadow: 1px 1px 1px #ccc;
  }
  .content.map {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .map-link {
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
    padding: 8px;
    font-size: 18px;
    background-color: white;
    border: 1px solid #333;
    z-index: 2;
    font-weight: 200;
  }
  .map-link:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  @media screen and (max-width: 768px) {
    .container {
      width: 100%;
      height: 70vh;
    }
    .content.map-wrapper {
      height: 40vh;
    }
    .content.desc {
      font-size: 4.5vw;
    }
    .info {
      font-size: 4vw;
      text-align: center;
      margin-bottom: 15px;
    }
    .map-link {
      padding: 5px;
      font-size: 14px;
    }
  }
</style>
